import { createContext, useState, ReactNode, useContext } from 'react';

interface CommonContextShape {
  chatBotVisible: boolean;
  setChatBotVisible: (v: boolean) => void;
  leftPanelVisible: boolean;
  setLeftPanelVisible: (v: boolean) => void;
  leftPanelContent: string;
  setLeftPanelContent: (v: string) => void;
}

const CommonContext = createContext<CommonContextShape | undefined>(undefined);

export const CommonProvider = ({ children }: { children: ReactNode }) => {
  const [chatBotVisible, setChatBotVisible] = useState(false);
  const [leftPanelVisible, setLeftPanelVisible] = useState(false);
  const [leftPanelContent, setLeftPanelContent] = useState('');

  return (
    <CommonContext.Provider value={{ chatBotVisible, setChatBotVisible, leftPanelVisible, setLeftPanelVisible, leftPanelContent, setLeftPanelContent }}>
      {children}
    </CommonContext.Provider>
  );
};

export const useCommon = () => {
  const ctx = useContext(CommonContext);
  if (!ctx) throw new Error('useCommon must be used within CommonProvider');
  return ctx;
};

export { CommonContext };
